// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  //API_URL: "https://login.fluidfintec.com/",
  //API_ADMIN_URL: "https://admin.fluidfintec.com/",
  // API_URL: "https://staging.api.fluidfintec.com",  //edex-backend KenRoy
  // API_ADMIN_URL: "https://staging.api.fluidfintec.com",  //edex-admin-multiapp
  //API_ADMIN_URL: "https://admin.edexpay.net",  //edex-admin-multiapp
  //API_URL: "https://edexpay.net",
  //API_URL: "https://dev.edexpay.net",
  API_URL: "https://apg.api.fluidfintec.com",  //edex-backend KenRoy
  API_ADMIN_URL: "https://apg.api.fluidfintec.com",
  production: false,
  testnet: true,
  horizon: 'https://horizon-testnet.stellar.org',
  // merchants_ids: ['61c1f3b0ab12798ce258c5d0']
  merchants_ids: ['624a913fb929987017bbc244'],
  payrix: {
    merchant:'t1_mer_63776f943208c754fb5fe3c',
    api:'849afecafdcb4b2454ab92237018e4e9'
  },
    stripePubkey:'pk_live_51QKpJAIS49q2cg4YiPjGL4RAX6BeL2nViI4ibwn634nNbsA62xqClrAzoIkqOOY2kvv5uT8PuDQ4tLXHf8RUyfDY00nupGvsDs',
    // stripePubkey:'pk_live_51MVwuvCFv9B2FlUPKeYcsDWqw576B8bFgDDItQAbt9pAnkTijYkI5fuWiWIm4fI2J1PoPsnpo9B9YJ3KbWUjhJKs00vkVd1lOT',
  // stripePubkey:'pk_test_51MVwuvCFv9B2FlUPoqp74VeJ6b060IKcpWxEWfMS5rIMG7OvIwGARaqWg98QJyd5OxrBgEepOadfnhcu1Q6UaLwn00xLkMCPCL',
  // paypalClientId: 'AQipO0pKmuzU9vOVo3ImVu4LftvsmzCSpvMy_-_CgoKlp_Zo9_vX0rPWtIipLIoDFqOxuzQvaqG7nRlw',
  lunexSeller:'APG01D999TEST',
  // lunexSeller:'APG01D999',
  paypalClientId:'sb'
};

/*
 * In development mode, for easier debugging, you can ignore zone related error
 * stack frames such as `zone.run`/`zoneDelegate.invokeTask` by importing the
 * below file. Don't forget to comment it out in production mode
 * because it will have a performance impact when errors are thrown
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
